export default "__VITE_ASSET__DFbH4Y0B__"